import {
  combineEpics,
} from 'redux-observable';
import {
  fetchDataEpic as fetch_CCPY_CC,
} from './fetchedData/countryCountryProductYearByCountryCountry';
import {
  fetchDataEpic as fetch_CCPY_CP,
} from './fetchedData/countryCountryProductYearByCountryProduct';
import {
  fetchDataEpic as fetch_CCY_C,
} from './fetchedData/countryCountryYearByCountry';
import {
  fetchDataEpic as fetchCountryLevelMapping,
} from './fetchedData/countryLevelMapping';
import {
  fetchDataEpic as fetchCountryMetadata,
} from './fetchedData/countryMetadata';
import {
  fetchDataEpic as fetchGroupsMetadata,
} from './fetchedData/groupsMetadata';
import {
  fetchDataEpic as fetchGroupMembersMetadata,
} from './fetchedData/groupMembersMetadata';

import {
  fetchDataEpic as fetch_CPY_C,
} from './fetchedData/countryProductYearByCountry';
import {
  fetchDataEpic as fetch_CPY_P,
} from './fetchedData/countryProductYearByProduct';
import {
  fetchDataEpic as fetch_CY,
} from './fetchedData/countryYear';
import {
  fetchDataEpic as fetchLayout,
} from './fetchedData/layoutData';
import {
  fetchDataEpic as fetchProductLevelMapping,
} from './fetchedData/productLevelMapping';
import {
  fetchDataEpic as fetchProductMetadata,
} from './fetchedData/productMetadata';
import {
  fetchDataEpic as fetch_PY,
} from './fetchedData/productYear';
import {
  fetchDataEpic as fetchYearly,
} from './fetchedData/yearlyData';

const rootEpic = combineEpics(
  fetch_CPY_C,
  fetch_CPY_P,
  fetch_CCY_C,
  fetch_CCPY_CC,
  fetch_CCPY_CP,
  fetchCountryLevelMapping,
  fetchCountryMetadata,
  fetchGroupsMetadata,
  fetchGroupMembersMetadata,
  fetchProductMetadata,
  fetch_CY,
  fetch_PY,
  fetchYearly,
  fetchProductLevelMapping,
  fetchLayout,
);

export default rootEpic;
